/* eslint-disable import/no-anonymous-default-export */
import { SET_TEAMS_CONTEXT } from '../actionConstants';

export default (state = false, action) => {
  switch (action.type) {
    case SET_TEAMS_CONTEXT:
      return action.payload;
    default:
      return state;
  }
};
